import Input from 'components/Input';
import * as React from 'react';
import ReactDOM from 'react-dom';
import { InputChangeHandler } from 'types/typescript/eventHandlers';

/**
 * ## Number-only [Input](/internal/components/Input).
 *
 *
 * ```example
 * <NumberInput />
 * ```
 */

type Props = {
  onChange?: (value: string) => void;
  value?: string | number;
};

type State = {
  value: string | number;
};

class NumberInput extends React.Component<Props, State> {
  state = {
    value: this.props.value || '',
  };

  getInputNode() {
    return ReactDOM.findDOMNode(this.refs.input);
  }

  handleChange: InputChangeHandler = event => {
    let value = event.target.value.replace(/^(?!\d+\.?\d)$/, '');
    const values = value.split('.');

    if (values[1] && values[1].length > 2) {
      value = values[0] + '.' + values[1].substr(0, 2);
    }

    // @ts-ignore - typescript thinks that `value` is always a string
    // but someone intentionally added this isNaN check so i don't
    // feel super comfortable deleting it
    if (!isNaN(value)) {
      this.setState({ value });
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }
  };

  render() {
    return (
      <Input
        {...this.props}
        ref="input"
        type="text"
        value={this.state.value}
        onChange={this.handleChange.bind(this)}
      />
    );
  }
}

export default NumberInput;
